export default "__VITE_ASSET__DkhNgr8o__"